document.addEventListener("DOMContentLoaded", async () => {
	const { initAccordion } = await import("@utils/accordion");
	initAccordion();

	const { loadMoreItems } = await import("@utils/loadMoreItems");
	loadMoreItems(".js-load_more_items");
});
